import * as React from 'react';

import { sendProgramInvitation } from 'bundles/internal-enterprise/utils/apiUtils';
import Button from 'bundles/internal-ui/components/buttons/Button';
import Card from 'bundles/internal-ui/components/cards/Card';
import TextBox from 'bundles/internal-ui/components/forms/TextBox';
import UiSnackbar, { openSnackbar } from 'bundles/internal-ui/components/snackbar/Snackbar';

import _t from 'i18n!nls/internal-enterprise';

type State = {
  errorMessage: string | null;
  programId: string;
  email: string;
  name: string;
};

class EnterpriseProgramInvitation extends React.Component<{}, State> {
  state: State = {
    errorMessage: null,
    programId: '',
    name: '',
    email: '',
  };

  handleUpdateText = (e: React.SyntheticEvent<HTMLInputElement>) => {
    // @ts-expect-error TSMIGRATION
    this.setState({
      [e.currentTarget.name]: e.currentTarget.value,
    });
  };

  onSubmitProgramInvitation = () => {
    const { programId, name, email } = this.state;
    sendProgramInvitation(programId, email, name).then((res) => {
      res.json().then((data) => {
        if (res.ok) {
          openSnackbar({ message: _t('Program invitation successfully sent!') });
          this.setState({ programId: '', email: '', name: '', errorMessage: null });
        } else {
          this.setState({ errorMessage: JSON.parse(data.message).description ?? 'Something went wrong.' });
        }
      });
    });
  };

  render() {
    const { errorMessage, programId, name, email } = this.state;
    return (
      <div className="rc-EnterpriseToolsHome">
        <Card>
          <h3>Program Invitation</h3>
          <TextBox
            placeholder={_t('Program ID')}
            name="programId"
            onUpdateField={this.handleUpdateText}
            currentValue={programId}
          />
          <TextBox placeholder={_t('Name')} name="name" onUpdateField={this.handleUpdateText} currentValue={name} />
          <TextBox placeholder={_t('Email')} name="email" onUpdateField={this.handleUpdateText} currentValue={email} />
          <br />
          <Button
            text={_t('Send Invitation')}
            btnStyle="info"
            disabled={!programId || !name || !email}
            onClick={this.onSubmitProgramInvitation}
          />
          <UiSnackbar />
          {errorMessage && (
            <div>
              <br />
              <pre style={{ whiteSpace: 'pre-wrap' }}>{errorMessage}</pre>
            </div>
          )}
        </Card>
      </div>
    );
  }
}

export default EnterpriseProgramInvitation;
